module.exports = __webpack_public_path__ + "img/个人简历-工作成就-带文字图标-灰.c98354e0.png";